module.exports = __webpack_public_path__ + "static/img/params-tips.aa6f2de9.png";